import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import AppleSelectorLayout from '../AppleSelectorLayout';
import SetVariableMutation from '../../mutations/SetVariable';
import GameQuery from '../../query/GameQuery';
class AppleSelector extends Component {
	render() {
		const { variable, MinimumSize, Price, DaysPayables } = this.props;
		return (
			<GameQuery>
				{
					query => (
						<SetVariableMutation>
							{setVariable => (
								<div
									className={`apple-selector ${
										!variable.disabled
											? 'apple-selector-active'
											: 'apple-selector-disabled'
									}`}
								>
									<AppleSelectorLayout>
										<AppleSelectorLayout.Item
											onClick={() => this.handleClick(setVariable, 1, query.game)}
											active={variable.value === 1}
										>
											<Icon icon={'mellino'}>
												<AppleSelectorLayout.ItemLabel
													minimumSize={MinimumSize[0].value}
													price={Price[0].value}
													daysPayables={DaysPayables[0].value}
												/>
											</Icon>
										</AppleSelectorLayout.Item>
										<AppleSelectorLayout.Item
											onClick={() => this.handleClick(setVariable, 2, query.game)}
											active={variable.value === 2}
										>
											<Icon icon={'tafaha'}>
												<AppleSelectorLayout.ItemLabel
													minimumSize={MinimumSize[1].value}
													price={Price[1].value}
													daysPayables={DaysPayables[1].value}
												/>
											</Icon>
										</AppleSelectorLayout.Item>
										<AppleSelectorLayout.Item
											onClick={() => this.handleClick(setVariable, 3, query.game)}
											active={variable.value === 3}
										>
											<Icon icon={'manzanita'}>
												<AppleSelectorLayout.ItemLabel
													minimumSize={MinimumSize[2].value}
													price={Price[2].value}
													daysPayables={DaysPayables[2].value}
												/>
											</Icon>
										</AppleSelectorLayout.Item>
									</AppleSelectorLayout>
								</div>
							)}
						</SetVariableMutation>
					)
				}
			</GameQuery>
		);
	}
	handleClick(setVariable, value, game) {
		const { variable } = this.props;
		const { name, year, disabled } = variable;
		!disabled &&
			setVariable({
				variables: {
					value,
					gameID: game.id,
					submission:game.lastSubmission,
					name,
					year,
				}
			});
	}
}
AppleSelector.propTypes = {
	variable: PropTypes.object,
	onClick: PropTypes.func,
	MinimumSize: MultiYearScalarType,
	Price: MultiYearScalarType,
	DaysPayables: MultiYearScalarType
};
AppleSelector.defaultProps = {
	onClick: n => console.log('selected item', n)
};

export default AppleSelector;
